import React, { useState } from 'react'
import { useLocation, useNavigate } from 'react-router-dom'
import { Pdf, Sms, Whatsapp } from '../../assests/ExportImageIcon'
import { showToast } from '../../componants/toast/toastService'
import './wishlist.css'

const BackArrow = () => (
    <svg width="18" height="18" viewBox="0 0 18 18" fill="none">
        <path d="M15 9H4M8 5l-4 4 4 4" stroke="#026D4D" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round" />
    </svg>
)

const CheckIcon = () => (
    <svg width="12" height="12" viewBox="0 0 14 14" fill="none">
        <path d="M3 7.2l2.4 2.4L11 4.2" stroke="#fff" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round" />
    </svg>
)

// PDF has no backend support yet (no export/generate endpoint) — kept visible
// to match Figma but disabled, rather than wired to nothing.
const EXPORT_OPTIONS = [
    { key: 'pdf', icon: Pdf, title: 'PDF', subtitle: 'Coming soon', disabled: true },
    { key: 'whatsapp', icon: Whatsapp, title: 'Whatsapp', subtitle: 'Invite via WhatsApp' },
    { key: 'sms', icon: Sms, title: 'SMS', subtitle: 'Invite via SMS' },
]

const WishlishtSetting = () => {
    const navigate = useNavigate()
    const location = useLocation()
    const wishlistId = location.state?.wishlistId
    const shareLink = location.state?.shareLink
    const [exportType, setExportType] = useState(null)

    const handleSelect = (option) => {
        if (option.disabled) {
            showToast(`${option.title} export is coming soon`, 'info')
            return
        }
        if (!shareLink) {
            showToast('Share link not available yet', 'error')
            return
        }
        setExportType(option.key)
        const message = `Join my wishlist: ${shareLink}`
        if (option.key === 'whatsapp') {
            window.open(`https://wa.me/?text=${encodeURIComponent(message)}`, '_blank')
        } else if (option.key === 'sms') {
            window.open(`sms:?body=${encodeURIComponent(message)}`, '_blank')
        }
    }

    const handleDone = () => {
        navigate(wishlistId ? `/wishlist-detail?id=${wishlistId}` : '/wishlist')
    }

    if (!wishlistId) {
        return (
            <section className='allSearchArea commonTopPadding commonBottomPadding'>
                <div className='container'>
                    <p className='fare-extra-hint'>No wishlist in progress.</p>
                    <button type='button' className='commonBtn' onClick={() => navigate('/wishlist')}>Go to Wishlists</button>
                </div>
            </section>
        )
    }

    return (
        <section className='allSearchArea commonTopPadding commonBottomPadding'>
            <div className='container'>
                <div className='row g-4'>
                    <div className='col-md-12'>
                        <div className='commonMaxWidth'>
                            <div className='tripDocHeader mb-4' onClick={() => navigate(-1)}>
                                <BackArrow />
                                <span className='bsSectionTitle'>Settings</span>
                            </div>
                            <div className='mb-4'>
                                <div className='bgWhite commonBorder borderRadius20 paddingCommon20'>
                                    <div className='createWishlistStep__top'>
                                        <span>Share</span>
                                        <span>4/5</span>
                                    </div>
                                    <div className='createWishlistStep__track'>
                                        <div className='createWishlistStep__fill' style={{ width: '80%' }} />
                                    </div>
                                </div>
                            </div>

                            <div className='bgWhite commonBorder borderRadius20 paddingCommon20'>

                            <div className='bsSectionTitle'>Export</div>
                            <div className='createWishlistPrivacy'>
                                {EXPORT_OPTIONS.map((option) => (
                                    <div
                                        key={option.key}
                                        className={`createWishlistPrivacy__item ${exportType === option.key ? 'active' : ''} ${option.disabled ? 'disabled' : ''}`}
                                        onClick={() => handleSelect(option)}
                                    >
                                        <span className='createWishlistPrivacy__icon'>
                                            <img src={option.icon} alt="" />
                                        </span>
                                        <div className='createWishlistPrivacy__text'>
                                            <div className='createWishlistPrivacy__title'>{option.title}</div>
                                            <div className='createWishlistPrivacy__subtitle'>{option.subtitle}</div>
                                        </div>
                                        <span className='createWishlistPrivacy__radio'>
                                            {exportType === option.key && <CheckIcon />}
                                        </span>
                                    </div>
                                ))}
                            </div>

                            <button type='button' className='commonBtn w-100 mt-4' onClick={handleDone}>Done</button>

                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    )
}

export default WishlishtSetting
